<template>
  <div>
    <p class="linespace40"></p>

    <div class="container">
      <div class="row">
	<div class="col-12">
	  <div class="d-flex align-items-center justify-content-center">
	    <EasyDataTable
	      table-class-name="custom"
	      v-model:server-options="serverOptions"
	      :server-items-length="serverItemsLength"
	      :loading="loading"
	      :headers="headers"
	      :items="items"
	      :body-row-class-name="bodyRowClassNameFunction"
	      :rowsItems=[5,10,20]
	      :mustSort=true
	      @click-row="selectProduct"
	      style="width: 100%"
	      border-cell
	      />
	  </div>
	</div>
      </div>
    </div>

    <div class="container mt-4 mb-4">
      <form>
	<div class="card">
	  <div class="card-header text-left">Product Info</div>
          <div class="card-body">

            <div class="form-group row">
              <label for="product-name" class="col-sm-2 col-form-label">Product Name</label>
              <div class="col-sm-10">
		<input type="text" class="form-control" id="product-name" name="product-name" placeholder="" v-model="product_name" @change="change">
              </div>
            </div>

            <div class="form-group row">
              <label for="select2" class="col-sm-2 col-form-label">Upgrade Target Software</label>
              <div class="col-sm-10 text-left pad-4">
		<select class="custom-select size-select1 form-control" id="select1" v-model="software_type" @change="change">
                  <option selected></option>
		  <option v-for="option in software_type_list" :value="option.value">
		     {{ option.text }}
		  </option>
		</select>
              </div>
            </div>
            <div class="form-group row">
              <label for="select2" class="col-sm-2 col-form-label">Upgrade Target OS</label>
              <div class="col-sm-8 text-left pad-4">
		<select class="custom-select size-select2 form-control" id="select2" v-model="target_os" @change="change">
                  <option value="0" selected></option>
		  <option v-for="option in target_os_list" :value="option.value">
		    {{ option.text }}
		  </option>
		</select>
              </div>
              <div class="col-sm-2 d-flex align-items-center justify-content-center">
		<button type="button" class="bluebtn2" @click="add" v-bind:disabled="disable_add">Add</button>
	      </div>
            </div>

            <div class="form-group row">
              <label for="latest-version" class="col-sm-2 col-form-label">Sales Period (JST)</label>
	      <div class="col-sm-8 pad-4">
		<datepicker class="form-inline" v-model="start_date" style="display: inline-block" @update:modelValue="changeStart"/>
		<span class="ml-2 mr-2" style="padding-left: 20px; padding-right: 20px;">～</span>
		<datepicker class="form-inline" v-model="end_date" style="display: inline-block" @update:modelValue="changeEnd" v-bind:disabled="disabled_end"/>
              </div>
              <div class="col-sm-2 d-flex align-items-center justify-content-center">
		<button type="button" class="bluebtn2" @click="update" v-bind:disabled="disable_update">Update</button>
	      </div>
            </div>

            <div class="form-group row">
              <div class="offset-sm-4 col-sm-3 text-left pad-4">
		<div class="form-check d-flex align-items-center justify-content-end">
                  <div>
                    <input class="form-check-input" type="checkbox" id="checkPeriod" v-model="check_period" @change="check_period_change">
                    <label class="form-check-label" for="checkPeriod">Sales Period not specified</label>
                  </div>
		</div>
              </div>
              <div class="offset-sm-3 col-sm-2 d-flex align-items-center justify-content-center pad-4">
		<button type="button" class="bluebtn2" @click="del" v-bind:disabled="disable_update">Delete</button>
	      </div>
            </div>

	  </div>
	</div>
      </form>
    </div>
    
    <p class="linespace20"></p>
    <div class="container">
      <div class="text-right">
	<router-link to="./menu2.html">
	  <div class="greenbtnM">Close</div>
	</router-link>
      </div>
    </div>
    <p class="linespace20"></p>
  </div>

  <ConfirmDialog />
  <ErrorDialog />
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { checkMaintenance, getSoftwareTypeList, getTargetOSList, getProductList, addProduct, updateProduct, deleteProduct } from '../server';
import { error } from './ErrorDialog.vue';
import { confirm } from './ConfirmDialog.vue';

checkMaintenance();

const headers = [
    {
	text: 'Product ID',
	value: 'product_id',
	sortable: true
    },
    {
	text: 'Product Name',
	value: 'product_name',
	sortable: true
    },
    {
	text: 'Upgrade Target Software',
	value: 'software_code',
	sortable: true
    },
    {
	text: 'Upgrade Target OS',
	value: 'target_os_name',
	sortable: true
    },
    {
	text: 'Sales Period (JST)',
	value: 'sale_start_date'
    },
    {
	value: 'sale_end_date'
    }
];

const items = ref([]);

const loading = ref(false);
const serverItemsLength = ref(0);
const serverOptions = ref({
    page: 1,
    rowsPerPage: 5,
    sortBy: 'product_id',
    sortType: 'asc'
});

const loadProductsFromServer = async() => {
    loading.value = true;
    try {
	let res = await getProductList(serverOptions.value);
	items.value = res.serverCurrentPageItems;
	serverItemsLength.value = res.serverTotalItemsLength;
    }
    catch(e) {
	console.log(e)
    }
    finally {
	loading.value = false;
    }
};

loadProductsFromServer();

watch(serverOptions, (value) => { loadProductsFromServer(); }, { deep: true });

const software_type_list = ref([]);
const target_os_list = ref([]);

const loadSoftwareTypesFromServer = async() => {
    try {
	let res = await getSoftwareTypeList();
	software_type_list.value = res.softwareTypes;
    }
    catch(e) {
	console.log(e)
    }
};

const loadTargetOSFromServer = async() => {
    try {
	let res = await getTargetOSList(true);
	target_os_list.value = res.targetOS;
    }
    catch(e) {
	console.log(e)
    }
};

loadSoftwareTypesFromServer();
loadTargetOSFromServer();

const selected = ref(null);
const selected_item = ref(null);
const product_name = ref('');
const software_type = ref('');
const target_os = ref('0');
const start_date = ref('');
const end_date = ref('');

const disable_add = ref(true);
const disable_update = ref(true);

const check_period = ref(false);
const disabled_end = ref(false);

const selectProduct = (item) => {
    selected.value = item.product_id;
    selected_item.value = item;
    product_name.value = item.product_name;
    software_type.value = item.software_code;
    target_os.value = item.target_os;
    start_date.value = item.sale_start_date;
    end_date.value = item.sale_end_date;

    disable_update.value = false;

    if (item.sale_end_date == '9999-12-31 23:59:59') {
	disabled_end.value = true;
	check_period.value = true;
    } else {
	disabled_end.value = false;
	check_period.value = false;
    }
};

const change = () => {
    if (!disable_add.value) {
	return;
    }
    disable_add.value = false;
};

const changeStart = (data) => {
    start_date.value = data;
    change();
}

const changeEnd = (data) => {
    end_date.value = data;
    change();
}

const add = async() => {
    if (product_name.value == '') {
	error('input product name');
	return;
    }
    if (software_type.value == '') {
	error('input software type');
	return;
    }
    if (target_os.value == '0') {
	error('input target os');
	return;
    }
    if (start_date.value == '') {
	error('input start date');
	return;
    }
    if (end_date.value == '') {
	error('input end date');
	return;
    }
    let product = {
	product_name: product_name.value,
	software_code: software_type.value,
	target_os: target_os.value,
	sale_start_date: start_date.value,
	sale_end_date: end_date.value
    };
  
    try {
	let res = await addProduct(product, serverOptions.value);
    }
    catch(e) {
	console.log(e)
    }
    await loadProductsFromServer();
};

const update = async() => {
    if (product_name.value == '') {
	error('input product name');
	return;
    }
    if (software_type.value == '') {
	error('input software type');
	return;
    }
    if (target_os.value == '0') {
	error('input target os');
	return;
    }
    if (start_date.value == '') {
	error('input start date');
	return;
    }
    if (end_date.value == '') {
	error('input end date');
	return;
    }
    let product = {
	product_id: selected_item.value.product_id,
	product_name: product_name.value,
	software_code: software_type.value,
	target_os: target_os.value,
	sale_start_date: start_date.value,
	sale_end_date: end_date.value
    };
  
    try {
	let res = await updateProduct(product);
    }
    catch(e) {
	console.log(e)
    }
    await loadProductsFromServer();
};

const del = () => {
    confirm(realDel)
};

const realDel = async() => {
    let product = {
	product_id: selected_item.value.product_id,
    };
  
    try {
	let res = await deleteProduct(product);
	disable_add.value = true;
	disable_update.value = true;

	selected.value = null;
	selected_item.value = null;
	product_name.value = '';
	software_type.value = 0;
	target_os.value = '0';
	start_date.value = '';
	end_date.value = '';

	check_period.value = false;
	disabled_end.value = false;
    }
    catch(e) {
	console.log(e)
    }
    await loadProductsFromServer();
};

const bodyRowClassNameFunction = (item, index) => {
  let result = 'odd-row';
  if (item.product_id == selected.value) {
    result = 'select-row';
  }
  return result;
};

const check_period_change = async () => {
    disabled_end.value = !disabled_end.value;
    if (disabled_end.value){
	end_date.value = '9999-12-31 23:59:59';
    } else {
	end_date.value = ''
    }
};

</script>
    
<style>
.select-row {
  --easy-table-body-row-background-color: #f56c6c;
}
.odd-row {
  --easy-table-body-row-background-color: #ffffff;
}
.custom {
    --easy-table-header-background-color: #9df5bc;
}
</style>
